<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  :useMultipart="true"
                  @action="masterAction"
                  ref="master"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Aplica cambio')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['apply_change', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-if="isVisible" v-bind="colOptions">
                <a-form-item :label="$t('Fecha')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['fecha', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-if="isVisible" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Observación')">
                  <a-textarea auto-size
                              v-decorator="['obs_workstation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
                  <a-upload
                    name="profile_file"
                    :before-upload="beforeUpload"
                    :fileList="master.uploads.profileFile"
                    :remove="() => { master.uploads.profileFile = [] }">
                    <a-button style="width: 100%">Seleccionar archivo</a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        isVisible: true,
        loadingBtns: {},
        tipoRecomendacion: {h_lookup_type: 'TYPE_MEDICAL_RECOMMEN'},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return data
          },
          endpoint: 'workstation',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_workstation] === record.id_workstation
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_workstation'
            },
            columns: [
              {title: 'ID Lugar de trabajo', dataIndex: 'id_workstation', sorter: true},
              {title: 'Aplica cambio', dataIndex: 'applychange_desc', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha_desc', sorter: true},
              {title: 'Observación', dataIndex: 'obs_workstation', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'fecha'},
            {name: 'obs_workstation'},
            {name: 'apply_change', type: 'boolean'}
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break

          case 'masterEdit':
            if (action.record.apply_change) {
              this.isVisible = false
            } else {
              this.isVisible = true
            }
            break

          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }

            if (!JsUtils.isEmpty(action.changedFields.apply_change)) {
              if (action.changedFields.apply_change.value) {
                this.isVisible = false
              } else {
                this.isVisible = true
              }
            }
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_workstation] = record.id_workstation
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('workstation/download', {
          id_workstation: record.id_workstation
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_workstation]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/LugarDeTrabajo.vue